import dayjs from 'dayjs';
import 'dayjs/locale/ja';

dayjs.locale('ja');

export function formatDate(dt) {
  const dt2 = (dt instanceof dayjs) ? dt : dayjs(dt);
  return dt2.format('YYYY-MM-DD');
}

export function formatDatetime(dt) {
  const dt2 = (dt instanceof dayjs) ? dt : dayjs(dt);
  return dt2.format('YYYY-MM-DD HH:mm');
}

export function formatVisibleDate(dt) {
  const dt2 = (dt instanceof dayjs) ? dt : dayjs(dt);
  return dt2.format('M/D(ddd)');
};

export function formatVisibleDatetime(dt) {
  const dt2 = (dt instanceof dayjs) ? dt : dayjs(dt);
  return dt2.format('M/D(ddd) HH:mm');
};

/** 次の指定曜日を返す。0=日,6=土 */
export function getNextWeekday(targetDow, from = dayjs()) {
  const todayDow = from.day();
  const diff = (targetDow - todayDow + 7) % 7 || 7;
  return formatDate(from.add(diff, 'day'));
}
